import { ConfigTransformFunc } from './types'

import { BIBME, CHEGG, CITATION_MACHINE, EASYBIB } from '../types'

// These all must unfortunatly stay as JS files (not typescript) because
// the build script interprets these in node. Running rollup with ts-node
// is not trivial.
import bibme from './bibme'
import citationmachine from './citationmachine'
import easybib from './easybib'
import chegg from './chegg'

export const sites = {
  [BIBME]: bibme as ConfigTransformFunc,
  [CITATION_MACHINE]: citationmachine as ConfigTransformFunc,
  [EASYBIB]: easybib as ConfigTransformFunc,
  [CHEGG]: chegg as ConfigTransformFunc,
}

export const getWidgetProps: ConfigTransformFunc = config => {
  const { site } = config
  if (!site || !sites[site]) {
    throw new Error(
      `Invalid site property passed to upload-widget: '${site}'.\nSelect a valid site name: [${Object.keys(sites).join(
        ', '
      )}]`
    )
  }

  return sites[site](config)
}

export default getWidgetProps
